<mat-drawer-container fullscreen>

    <mat-drawer #drawer opened mode="side">
    </mat-drawer>

    <mat-drawer-content class="layout__flexbox">
        <app-header></app-header>
        <main>
            <router-outlet></router-outlet>
        </main>
        <app-footer></app-footer>
    </mat-drawer-content>

</mat-drawer-container>